import $ from 'jquery';
import CPMeta from '../cp-meta/index';
import { PLAYLIST, RECOMMEND } from '../constants';

const isUserReportMode = SF.getParam('cnucc') === "1";

/**
 *
 * @type {{addComma: (function(*=): string), formatDate: (function(string): string), toVideoTimeFormat: (function((number|string)): string), kakaoTVType: (function(*): string), convert: (function(*): Clip)}}
 */
const Converter = {
  /**
   * @see {@link http://hehet.dev.daum.net/scripts/common/modules/number/index.html}
   * @param {number} number
   * @returns {string}
   */
  addComma(number) {
    return $.number.addComma(number);
  },
  /**
   * @see {@link http://hehet.dev.daum.net/scripts/common/modules/format/index.html}
   * @param {string} yyyyMMddHHmmss
   * @returns {string}
   */
  formatDate(yyyyMMddHHmmss) {
    return $.format.prettydate(yyyyMMddHHmmss);
  },
  /**
   * 초를 동영상 시:분:초 포맷으로 환산한다. '시' 단위가 00: 일 경우는 제거하고 분이 00:이면 남겨둔다
   * 00:04:11 => 04:11
   * 00:00:11 => 00:11
   * @param {number|string} seconds
   * @returns {string}
   */
  toVideoTimeFormat(seconds) {
    return (new Date(seconds * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0].replace(/^00:/, '');
  },
  escapeNonTagString(str) {
    const htmlRegex = /&lt;\s*b[^&gt;]*&gt;.*?&lt;\s*\/\s*b&gt;/g;
    const escapeTagSigns = (str) => str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const unescapeTags = (str) => str.replace(htmlRegex, ($m) => $m.replace(/&lt;/g, '<').replace(/&gt;/g, '>'));
    return unescapeTags(escapeTagSigns(str));
  },
  /**
   * 카카오TV이면서 플레이리스트인 타입인지 구분. 리턴 값으로 동영상 하단이 추천영상인지 플레이리스트인지 구분된다.
   * @param {string} playlistId
   * @returns {string}
   */
  kakaoTVType(playlistId) {
    return playlistId === '' ? RECOMMEND : PLAYLIST;
  },

  makeDupURL(dup_orig_count, dup_docids) {
    const periodParamObj = ['sd', 'ed', 'period'].map((param) => ({ param: SF.getParam(param), key: param }))
                                                 .filter(param => !!param.param)
                                                 .reduce((obj, param) => $.extend(obj, { [param.key]: param.param }), {});
    const mergedParams   = $.extend({
      w: 'vclip',
      q: decodeURIComponent(window.utf8Query),
      dup_filter: 'n',
      dup_orig_count,
      dup_docids,
      spacing: SF.getParam('spacing') || 0
    }, periodParamObj);

    return '?' + $.param(mergedParams);
  },
  /**
   * API 데이터를 프론트에서 사용할 데이터 포맷으로 변환한다
   * @param {Object} ajaxData
   * @returns {Clip}
   */
  convert(ajaxData) {
    return ajaxData.map((clip) => {
      const dupInfo                = clip.dup_info || {};
      const playCountInt           = Number(clip.play_count) || 0;
      const cp                     = clip.bif_cp_id;
      const cpMeta                 = CPMeta.of(cp);
      const isEmbeddable           = clip.is_embeddable === 'true';
      const isYoutube              = cp === CPMeta.codes.YOUTUBE;
      const isYoutubeRestrictedAge = clip.is_youtube_restricted_age === 'true';
      const dupCount               = Number(dupInfo.dup_orig_count || "0");
      const isAdult                = clip.is_adult === 'true';
      const displayURL             = clip.landing_url;
      const thumbURL               = clip.repr_thumbnail_url_s2;
      const dsid                   = clip.dsid;
      const totalPlayCount         = this.addComma(playCountInt);
      const pdGradeIcon            = CPMeta.PDGradeToClassName(clip.kakao_tv_pd_level);
      const shouldDisplayPreview   = cpMeta.isFamily || (isYoutube && isEmbeddable && !isYoutubeRestrictedAge);
      const shouldDisplayPlayCount = playCountInt > 0;
      const isHot                  = playCountInt > 99999;
      const cpType                 = cpMeta.type;
      const kakaoTVType            = cpMeta.isFamily ? this.kakaoTVType(clip.kakao_tv_playlist_id) : '';

      return {
        bifChannelURL: clip.bif_channel_url,
        bifChannelId: clip.bif_channel_id,
        clipId: clip.clip_id || '',
        cp,
        cpURL: clip.bif_cp_url,
        cpName: clip.cp_group_name || '',
        cpType,
        dateString: this.formatDate(clip.reg_datetime || ''),
        displayURL,
        dsid,
        dupURL: this.makeDupURL(dupCount, dupInfo.dup_docids),
        duration: this.toVideoTimeFormat(clip.play_time || "0"),
        isAdult,
        isKakaoTVPlaylist: cpType === CPMeta.CPTypes.CP_TYPE_KAKAOTV && kakaoTVType === PLAYLIST,
        isHot,
        isUserReportMode,
        kakaoTVType,
        kakaoTVPlaylistId: clip.kakao_tv_playlist_id,
        kakaoTVPlaylistURL: clip.kakao_tv_playlist_url,
        kakaoTVPlaylistName: clip.kakao_tv_playlist_name,
        pdGradeIcon,
        dupCount,
        shouldDisplayPreview,
        shouldDisplayPlayCount,
        thumbURL,
        title: this.escapeNonTagString(clip.title),
        totalPlayCount,
        userName: clip.user_name,
        videoId: clip.video_id,
        isSMR: clip.is_smr === '1',
        isOrgDoc: true
      };
    });
  },
  /**
   *
   * @param {Clip} clip
   * @param {PlaylistItem} playlistItem
   * @returns {PlayListTemplateData}
   */
  mapClipToPlaylistTemplateData(clip, playlistItem) {
    return $.extend({}, playlistItem, {
      isKakaoTVPlaylist: clip.isKakaoTVPlaylist && playlistItem.type !== CPMeta.docTypes.KAKAO_POPULAR,
      kakaoTVPlaylistName: clip.kakaoTVPlaylistName,
      kakaoTVPlaylistURL: clip.kakaoTVPlaylistURL
    });
  },

  playlistToClipFormat(baseClip, apiResponse) {
    return $.extend({}, apiResponse, {
      documents: apiResponse.documents.map((clipData) => {
        return {
          videoId: clipData.vid,
          clipId: clipData.clipId,
          cp: baseClip.cp,
          cpName: baseClip.cpName,
          dateString: this.formatDate(clipData.date),
          title: clipData.title,
          thumbURL: clipData.thumbnail,
          displayURL: clipData.url,
          dsid: clipData.dsid,
          duration: clipData.playTime,
          totalPlayCount: clipData.playCount ? this.addComma(clipData.playCount) : '',
          s2Id: apiResponse.s2Id,
          type: apiResponse.type,
          cpType: baseClip.cpType,
          isKakaoTVPlaylist: baseClip.isKakaoTVPlaylist,
          bifChannelId: baseClip.bifChannelId,
          isSMR: baseClip.isSMR,
          isOrgDoc: false
        };
      })
    });
  }
};

export default Converter;


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/converter/index.js
 **/